import React, { useEffect, useState } from "react";
import "./NotFound.css";
import notFoundImage from './../../Assets/images/404.svg'
import backicon from './../../Assets/icons/backIcon.svg'
import { useNavigate } from "react-router-dom";
const NotFound = () => {
  const [state, setState] = useState({
    isLoading: true,
  });
  const navigate =useNavigate()
  useEffect(() => {
    setTimeout(() => {
      setState({ isLoading: false });
    }, 1000);
  }, []);

  return (
    <div className="not-found-container">
      {state.isLoading ? (
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <img
            className="not-found-404"
            src={notFoundImage}
            alt="404"
            height={600}
            width={600}
          />
          {/* <h3 className="error-text">404</h3> */}
          <p>Oops! The page you were looking for doesn’t exist.</p>
          <div className="backbutton backtologincontainer mt-2 mb-2" onClick={()=>{navigate('/')}}>
        <img src={backicon} alt="back" />
        <span className="backlogin">Return To Login Page</span>
      </div>
        </>
      )}
    </div>
  );
};

export default NotFound;
